export default "__VITE_ASSET__DkZ98VL4__"